

export const hermioneReviewerReviewHinge = {
  _id: 'hermioneReviewerReviewHingeId',
  email: 'hermione@email.com',
  profileReviewId: 'hermioneProfileReviewHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Hermione! This will really help me!',
  profileReviewedFirstName: 'Albus',
}

export const ronReviewerReviewBumble = {
  _id: 'ronReviewerReviewBumbleId',
  email: 'ron@email.com',
  profileReviewId: 'ronProfileReviewBumbleId',
  reviewerProfileId: 'ronReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ron! This will really help me!',
  profileReviewedFirstName: 'Albus',
}

export const harryReviewerReviewTinder = {
  _id: 'harryReviewerReviewTinderId',
  email: 'harry@email.com',
  profileReviewId: 'harryProfileReviewTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Harry! This will really help me!',
  profileReviewedFirstName: 'Albus',
}